import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DialogState } from './dialog.state';

const selectDialogState = createFeatureSelector<DialogState>('dialog');

export const selectIsDialogDisplayed = createSelector(selectDialogState, (state: DialogState) => state.isDialogDisplayed);

export const selectDialogContentType = createSelector(selectDialogState, (state: DialogState) => state.dialogContentType);

export const selectManageUserDialogDisplayed = createSelector(selectDialogState, (state: DialogState) => state.isManageUsersDialogDisplayed);
